/**
 * Formats a long string ID by truncating it and including a specified
 * number of characters at the start and end, separated by ellipses ('...').
 *
 * Example - 9e11b223-1288-4215-8acb-53b9caf8a0b2 -> 9e11...a0b2
 */
export const formatLongId = (id?: string, characters = 4): string | undefined => {
    if (!id) return undefined;

    if (id.length <= characters * 2) {
        return id;
    }

    return `${id.slice(0, characters)}...${id.slice(-characters)}`;
};
